import { JamPadEvent } from '../DataModels';
import { Box, Typography } from '@mui/material';
import EventActions from './EventActions.tsx';
import { MusicNote } from '@mui/icons-material';

interface Props { event: JamPadEvent | undefined, seeFullEvent: any }
export const EventPreview = ({ event, seeFullEvent } : Props) => {
    return <Box onClick={seeFullEvent} sx={{ 
                backgroundColor: "black", borderRadius: '4px', padding: '4px 8px',
                display: 'flex', flexDirection: 'row', alignItems: 'center',
                flexWrap: { xs: 'nowrap', md: 'wrap' },
            }}>
                <div style={{
                    flex:' 1 1 30%', display: 'flex',
                    padding: "10px"
                }}>
                    { event?.poster ?
                        <img src={event?.poster ?? undefined} alt={event?.title}
                            style={{ 
                                flex: '1', objectFit: 'contain', maxWidth: '100%', maxHeight: '42vh',
                                borderRadius: '2px', outline: "2px solid black",
                            }} loading='lazy' />
                    :
                        <MusicNote sx={{ width: '100%', fontSize: '80px', color: 'pink' }}/>
                    }
                </div>

                <Box sx={{ 
                    overflow: 'hidden',
                    flex: '1 0 38%', alignItems: 'center', justifyContent: 'center', textAlign: 'center',
                    display: 'flex', flexDirection: 'column', gap: '6px',
                    outline: "2px solid grey", margin: "8px", padding: '10px 14px 8px', borderRadius: '14px'
                }}>
                    <Typography sx={{ color: 'white',
                        fontWeight: 'bold', textWrap: 'nowrap' 
                    }} variant='body1'>
                        {event?.date.toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})} - { event?.date.toLocaleTimeString('en-US', {minute: '2-digit', hour: 'numeric'})}
                    </Typography>
                    
                    <Typography sx={{ color: 'white', fontVariant: 'small-caps' }} variant='body1'>
                        {event?.name}
                    </Typography>
                    <Typography sx={{ color: 'lightgray' }} variant='caption'>
                        <i>{event?.address.split("  ")[0]}</i>
                    </Typography>

                    <div style={{ flex: '1', display: 'flex', flexDirection: 'row',
                        alignItems: 'center', gap: '4px'
                    }}>
                        <Typography sx={{ outline: '2px solid lightblue', padding: '4px 8px', 
                            borderRadius: '12px', color: 'lightblue' }} variant='caption' fontWeight='bold'>
                            {event?.price === 0 ? "FREE" : "$" + event?.price} 
                        </Typography>
                        <Typography sx={{ outline: '2px solid lightblue', padding: '4px 8px', margin: '6px 4px',
                            borderRadius: '12px', color: 'lightblue' }} variant='caption' fontWeight='bold'>
                            {event?.age === 0 ? "All Ages" : event?.age + "+"} 
                        </Typography>
                        <Typography sx={{ 
                            display: 'flex', flexDirection: 'column', gap: '0px',
                            outline: '2px solid lightblue', padding: '0px 8px 4px',
                            borderRadius: '12px', color: 'lightblue', fontSize: '10px'
                        }} variant='caption' fontWeight='bold'>
                            {event?.rsvps} <span style={{ fontSize: '7px' }}>RSVPs</span>
                        </Typography>
                    </div>

                    <div style={{ 
                        maxWidth: '100%',
                        overflow: 'hidden', display: 'flex',
                        color: "white",
                    }}>
                        <div style={{ overflow: 'auto', padding: '10px 0',
                            flex: '1', display: 'flex', gap: '10px', alignItems: 'center'
                        }}>
                            { event?.artist_names.length ?? 0 > 0 ?
                                <Typography variant='body2' fontWeight='bold' sx={{ textAlign: 'center', color: 'lightgray'}}>
                                    Artists:
                                </Typography>
                            :
                                <Typography variant='body2' fontWeight='bold' sx={{ flex: '1 0 100%', textAlign: 'center', color: 'white'}}>
                                    [ No featured creators ]
                                </Typography>
                            }
                            { event?.artist_names.map((artist, i) => {
                                return <Typography key={i} variant='body2' sx={{ 
                                    flex: '1', textWrap: 'nowrap',
                                    outline: event?.artist_ids[i] ? "2px solid blue" : "2px solid gray",
                                    borderRadius: '14px', padding: "6px 10px", 
                                    background: event?.artist_ids[i] ? 'darkblue' : 'lightgray', 
                                    color: event?.artist_ids[i] ? 'white' : 'black'
                                }} onClick={(e) => {
                                    e.stopPropagation();
                                    console.log(event?.artist_names, event?.artist_ids);
                                }}>
                                    {artist}
                                </Typography>
                            })}
                        </div>
                    </div>
                    <div style={{ flex: '1 0 100%' }}>
                        <EventActions event={event}/>
                    </div>
                </Box>
            </Box>
};
export default EventPreview;